define('NetSuite.SuiteCommCPQ.Main.Model', [
        'Backbone', 'Utils', 'NetSuite.SuiteCommCPQ.Main.Debug'
    ],
    function MainModel(Backbone, Utils, Debugger) {
        'use strict';
        // this.get() - get data from back-end (NetSuite.SuiteCommCPQ.Main.ServiceController)
        var Main_Model = Backbone.Model.extend({
            url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Main.Service.ss')),
            getTitle: function getTitle() {
                return this.get('title');
            },
            getUrl: function getContent() {
                return this.get('url');
            },
            _init: function() {
                Debugger.setGlobal('main_model', this);
            }
        });
        return Main_Model;
    }
);
